import { render, staticRenderFns } from "./LoginBrandingSection.vue?vue&type=template&id=5af89058&scoped=true&"
import script from "./LoginBrandingSection.vue?vue&type=script&lang=js&"
export * from "./LoginBrandingSection.vue?vue&type=script&lang=js&"
import style0 from "./LoginBrandingSection.vue?vue&type=style&index=0&id=5af89058&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af89058",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
